








































import {Component, Prop, Vue} from 'vue-property-decorator';
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import {TranslateResult} from 'vue-i18n';
import Environment from "@flashpointbv/solar-ui-environment";

@Component({
  name: 'catalog-product-review-form',
  components: {
    ValidationObserver,
    ValidationProvider
  }
})

export default class extends Vue {
  $refs!: {
    form: InstanceType<typeof ValidationObserver>;
  }

  @Prop({required: true}) private productId: string;
  @Prop({required: true}) private productName: string;

  private showReviewForm: boolean = false;
  private savedReview: boolean = false;
  private review: object = {
    title: null,
    nickname: null,
    email: null,
    message: null,
    rating: null,
  };

  private hasError: boolean = false;
  private errorMessage: TranslateResult = '';

  private async submitForm(): Promise<void> {
    if (await this.$refs.form.validate()) {
      try {
        const {data} = await this.$solarClient.post(`api/catalog/product/${this.productId}/review`, this.review);

        if (data.hasOwnProperty('status')) {
          this.hasError = true;
          this.errorMessage = data['message'];
        }

        this.hasError = false;
        this.review = {
          title: null,
          nickname: null,
          message: null,
          rating: null,
        };

        this.$refs.form.reset();

        this.showReviewForm = false;
        this.savedReview = true;
      } catch (err) {
        this.hasError = true;
        this.errorMessage = this.$t('Unable to place review');
      }
    }
  }
}
